import { render, staticRenderFns } from "./ActionDetails.vue?vue&type=template&id=65ae6851&scoped=true&lang=html&"
import script from "./ActionDetails.vue?vue&type=script&lang=js&"
export * from "./ActionDetails.vue?vue&type=script&lang=js&"
import style0 from "./ActionDetails.vue?vue&type=style&index=0&id=65ae6851&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ae6851",
  null
  
)

export default component.exports